var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtableSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.6 93.4",
    style: {
      enableBackground: "new 0 0 111.6 93.4"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FCB400;}\n\t.st1{fill:#18BFFF;}\n\t.st2{fill:#F82B60;}\n\t.st3{fill:#BA1E45;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 93.4,
    width: 111.6,
    x: 253.9,
    y: 196.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,1.2L8.3,18.4c-2.3,1-2.3,4.2,0,5.2L50,40.2c3.7,1.4,7.7,1.4,11.4,0l41.8-16.6c2.3-1,2.4-4.2,0-5.2 L61.7,1.2C57.9-0.4,53.6-0.4,49.8,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5,49.2v41.4c0,2,2,3.4,3.8,2.6l46.6-18c1.1-0.4,1.7-1.4,1.7-2.6V31.2c0-2-2-3.4-3.8-2.6l-46.6,18 C60.1,47,59.5,48,59.5,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,31.3v38.9c0,2.1,2.4,3.4,4.2,2.5l29.1-14l1.4-0.7L0.9,29.4C0.4,29.9,0,30.5,0,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.4,46.3L4.1,28.7c-0.9-0.3-1.8-0.2-2.5,0.2c-0.2,0.1-0.5,0.3-0.8,0.5L34.7,58l13.8-6.6 C50.8,50.3,50.6,47.1,48.4,46.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtableSymbol);
export default __webpack_public_path__ + "static/media/airtable-symbol.aeb59336db9d642ed6113c5ab5864632.svg";
export { ForwardRef as ReactComponent };